/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateMasterVariant } from './updateMasterVariant';
import { updateListingVariant } from './updateListingVariant';

export const changeVariantCustomField = createAsyncThunk(
  'products/changeVariantCustomField',
  async ({
    productId,
    variantId,
    layer,
    listingId,
    listingVariantId,
    channelId,
    title,
    value,
  }, { dispatch }) => {
    const meta = { [title]: value };

    if (layer === 'master') {
      await dispatch(updateMasterVariant({ productId, variantId, data: { meta } })).unwrap();
      return {
        productId, variantId, layer, title, value, meta,
      };
    }

    if (layer === 'listing') {
      await dispatch(updateListingVariant({
        listingProductId: listingId,
        listingVariantId,
        masterProductId: productId,
        channelId,
        data: { meta },
      })).unwrap();
      return {
        productId,
        variantId,
        layer,
        listingId,
        listingVariantId,
        channelId,
        title,
        value,
        meta,
      };
    }

    throw new Error(`Unsupported custom field layer: ${layer}`);
  },
);

export const reducer = (builder) => {
  builder
    .addCase(changeVariantCustomField.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(changeVariantCustomField.fulfilled, (state) => {
      state.isBusy = false;
    })
    .addCase(changeVariantCustomField.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot update variant custom field';
    });
};
